import TableSort from '@/mixins/TableSort'

export default {
  mixins: [TableSort],
  data () {
    return {
      tableColumns: [],
      tablePreferenceStorageKey: ''
    }
  },
  methods: {
    // Initialize saved column preferences and default sorting from localStorage
    initTablePreferences (storageKey, defaultColumns = [], defaultSort = '', tableRef = null) {
      this.tablePreferenceStorageKey = `table_pref_${storageKey}`

      // Setup initial sort state
      this.initSort(`${storageKey}_sort`, defaultSort, tableRef)

      // Load saved column preferences if available
      const savedConfig = localStorage.getItem(this.tablePreferenceStorageKey)
      if (savedConfig) {
        try {
          const parsed = JSON.parse(savedConfig)
          const savedMap = {}
          parsed.forEach(c => {
            savedMap[c.key] = c
          })

          // Merge saved visibility while preserving any newly added columns in code
          this.tableColumns = defaultColumns.map(col => {
            const saved = savedMap[col.key]
            return {
              ...col,
              visible: saved ? (col.locked ? true : saved.visible) : (col.defaultVisible !== false)
            }
          })
        } catch (e) {
          this.tableColumns = this.getDefaultColumnState(defaultColumns)
        }
      } else {
        this.tableColumns = this.getDefaultColumnState(defaultColumns)
      }
    },

    getDefaultColumnState (defaultColumns) {
      return defaultColumns.map(col => ({
        ...col,
        visible: col.defaultVisible !== false
      }))
    },

    // Check if a specific column is set to visible
    isColumnVisible (columnKey) {
      if (!this.tableColumns || !this.tableColumns.length) return true
      const col = this.tableColumns.find(c => c.key === columnKey)
      return col ? col.visible !== false : true
    },

    // Save updated column visibility to localStorage
    handleColumnPreferenceChange (newColumns) {
      this.tableColumns = newColumns
      if (this.tablePreferenceStorageKey) {
        const payload = newColumns.map(c => ({
          key: c.key,
          visible: c.visible !== false
        }))
        localStorage.setItem(this.tablePreferenceStorageKey, JSON.stringify(payload))
      }
    },

    // Handle sort triggered from the Columns dropdown
    handlePreferenceSortChange ({ key, active }, fetchCallback) {
      this.handleSort(key, active, fetchCallback)
    },

    // Reset columns back to initial default configuration
    handleResetColumnPreferences (defaultColumns) {
      if (this.tablePreferenceStorageKey) {
        localStorage.removeItem(this.tablePreferenceStorageKey)
      }
      this.tableColumns = this.getDefaultColumnState(defaultColumns)
    }
  }
}
